<app-navbar title="{{ service.pageTitle }}">
	<a class="btn btn-danger" routerLink="../"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>
<mat-tab-group [(selectedIndex)]="activeTabIndex" class="container" dynamicHeight>
	@for (tab of tabs; let i = $index; track i) {
		<mat-tab [disabled]="service.organizationData.id === null && tab.component !== 'primary'">
			<ng-template mat-tab-label> <i [class]="tab.icon"></i> &nbsp; {{ tab.label }} </ng-template>
			<ng-template matTabContent>
				@switch (tab.component) {
					@case ('primary') {
						<app-organization-primary [pageFunction]="pageFunction" />
					}
					@case ('bank') {
						<app-organization-bank-accounts />
					}
					<!-- This module is currently unused and has been commented out. It may be useful in the future. -->
					<!--									@case ('workers') {-->
					<!--										<app-organization-workers />-->
					<!--									}-->
					@case ('insurer') {
						<app-organization-insurer
							[organizationId]="service.organizationData.id"
							[isActive]="activeTabIndex() === i"
							[travelOrganizationGovernmentApproval]="service.travelOrganizationGovernmentApproval()"
						/>
					}
					@default {
						<p>Nieznany komponent zakładki.</p>
					}
				}
			</ng-template>
		</mat-tab>
	}
</mat-tab-group>
